module.exports = __webpack_public_path__ + "img/bg_white.99ac67ec.png";